var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_240_5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1137 73.2307C26.5235 60.408 15.4732 57.1051 12.5415 51.8595C9.38431 46.8081 7.12915 31.2654 17.7284 20.1912C28.3276 9.11706 38.7013 1.34571 44.1137 0.180006C49.3006 -1.17998 65.9887 5.42567 77.2645 11.2542C88.5403 17.0827 87.6382 20.1912 102.748 20.1912C117.857 20.1912 143.341 18.8312 165.216 42.1453C187.091 65.4594 184.835 63.5165 187.767 66.8193C190.699 70.1222 215.506 78.4764 229.939 77.8935C244.146 77.3107 276.62 68.1793 290.828 57.1052C305.035 46.031 332.999 21.5512 372.013 20.7741C411.028 20.1912 473.27 20.9684 502.813 77.6992C532.806 135.402 483.193 192.327 442.6 207.287C406.743 220.498 383.289 229.241 299.848 230.018C216.408 230.795 153.94 232.543 110.415 274.12C66.8908 315.503 127.78 346.005 169.049 323.274C210.319 300.543 238.959 276.063 293.083 256.635C347.207 237.206 411.93 225.549 452.523 263.823C493.115 302.097 471.24 351.834 448.012 373.982C424.784 395.936 390.055 415.364 323.979 421.97C257.903 428.381 248.882 458.884 269.178 469.181C289.475 479.478 298.495 478.312 353.296 456.164C408.096 434.21 456.356 426.439 487.026 467.821C504.391 491.135 478.682 509.981 471.24 508.038C463.798 506.095 475.074 499.684 477.329 492.495C479.584 485.307 475.074 467.821 452.523 461.993C429.971 456.164 405.164 460.05 373.592 480.061C342.02 500.072 291.73 531.158 236.704 496.186C181.678 461.215 212.574 412.644 242.793 393.799C272.787 374.953 357.806 375.731 385.544 342.702C413.283 309.674 364.12 299.183 338.863 311.034C299.848 329.102 250.912 378.451 196.788 395.936C142.664 413.422 44.3392 435.959 6.45261 336.291C-31.2085 237.206 105.003 173.093 181.678 169.207C258.354 165.321 293.76 165.321 335.029 165.321C376.298 165.321 425.235 152.304 431.324 122.579C437.187 92.6591 398.85 80.4192 377.877 88.1906C356.904 95.9619 334.352 108.979 311.801 121.219C289.249 133.459 253.392 158.521 181.002 131.516C158.45 123.162 151.008 125.687 133.643 125.687C116.279 125.687 86.9617 123.162 71.8521 107.619C56.7426 92.0762 53.8109 80.4192 44.1137 73.2307Z",
    fill: "#CF5700"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 83,
    r: 10,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 83,
    r: 10,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 117,
    r: 10,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351,
    cy: 209,
    r: 10,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 189,
    r: 10,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 341,
    r: 10,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 289,
    r: 10,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396,
    cy: 388,
    r: 10,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 486,
    r: 10,
    fill: "#FFB800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_240_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnake);
export default __webpack_public_path__ + "static/media/Snake.61d4a7fb519ca626ae36dde03b3445c9.svg";
export { ForwardRef as ReactComponent };